<template>
  <div
    v-if="showBanner"
    class="bg-warning-bg border-b border-warning/25 px-4 py-2.5 flex items-center justify-between flex-wrap gap-2"
  >
    <span class="text-warning text-sm">Please verify your email address to access all features.</span>
    <button
      @click="resendVerification"
      :disabled="loading"
      class="text-sm font-semibold text-warning underline disabled:opacity-50"
    >
      {{ loading ? 'Sending…' : 'Resend email' }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { extractApiError } from '@/services/api'
import { ref, computed } from 'vue'
import { toast } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'
import { authService } from '@/services/auth.service'

const authStore = useAuthStore()

const loading = ref(false)

const showBanner = computed(() => {
  return authStore.isAuthenticated && authStore.user && !authStore.user.email_verified
})

async function resendVerification() {
  if (!authStore.user?.email) return

  loading.value = true
  try {
    await authService.resendVerification({ email: authStore.user.email })
    toast.success('Verification email sent! Please check your inbox.')
  } catch (err) {
    toast.error(extractApiError(err, 'Failed to send verification email.'))
  } finally {
    loading.value = false
  }
}
</script>
